import { render } from "./Chat.vue?vue&type=template&id=2bc3d388&scoped=true&ts=true"
import script from "./Chat.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chat.vue?vue&type=script&setup=true&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=2bc3d388&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc3d388"],['__file',"src/components/Chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bc3d388"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bc3d388', __exports__)) {
    api.reload('2bc3d388', __exports__)
  }
  
  module.hot.accept("./Chat.vue?vue&type=template&id=2bc3d388&scoped=true&ts=true", () => {
    api.rerender('2bc3d388', render)
  })

}


export default __exports__